import React from 'react';
import S from './Responsive.styles';
const DesktopOnly = ({ children }) => {
    return React.createElement(S.DesktopOnly, null, children);
};
export default DesktopOnly;
